jQuery(function($) {
	$.fn.filterTags = function() {
		var selector = this.data('selector'),
			reset_selector = selector + ' [type="reset"]',
			tags_selector = selector + ' .tags__list a[data-field]';

		$(this).parent()
			.on({
				/**
				 * Remove tags on click and reload filter
				 */
				click: function(e) {
					var $link = $(this),
						$tag = $link.closest('.tags__item'),
						$connected_field = $('[id^="' + $link.data('field') + '"]').eq(0);

					if(!$connected_field.length) {
						$connected_field = $('[id^="' + $link.data('field').split('_0_')[0] + '"]').eq(0);
					}

					$tag.fadeOut(function() {
						$(this).remove();
					});

					switch($connected_field.prop('type')) {
						case 'radio':
						case 'checkbox':
							$connected_field.each(function() {
								$(this).attr('checked', false).change();
							});
							break;
						default:
							if($connected_field.is('select')) {
								$($connected_field.get(0).selectedOptions).map(function() {
									if(this.text === $tag.text().replace($link.text(), '').trim()) {
										var multiselect = $('#' + $connected_field.attr('id')).data('multiselect');

										if(multiselect) {
											multiselect.deselect(this.value);
										}
										else {
											$connected_field.val('');
										}
									}
								});
								$connected_field.change();
							}
							else {
								$connected_field.each(function() {
									$(this).val('').change().click();
								});
							}
					}

					return false;
				},
			}, tags_selector)
			.on({
				/**
				 * Reload cards placeholders and refresh input placeholder classes
				 */
				ready: function() {
					$(this).find('input[type="search"]').one('focus', function() {
						var that = this;
						setTimeout(function() {
							that.selectionStart = that.selectionEnd = 10000;
						}, 0);
					}).eq(0).each(function() {
						$(this).get(0).focus();
					});

					clearTimeout($.replaceTimer);
					$.replaceTimer = setTimeout(function() {
						$.polyfillMultiselects();
						$.polyfillPlaceholders();
					}.bind(this), 50);

					gridCards(this);
					$(this).find('.grid-cards').each(function() {
						gridCards(this);
					});
				}
			}, selector)
			.on({
				/**
				 * Fix reset button for ajax filters
				 */
				click: function() {
					var $form = $(this).parents('form');

					$form.find('input:not([type="submit"]), select, textarea').each(function() {
						switch(this.type.toLowerCase()) {
							case 'number':
							case 'text':
							case 'password':
							case 'textarea':
							case 'hidden':
								$(this).val('');
								break;
							case 'radio':
								$(this).attr('checked', false);
								$('[name="' + $(this).attr('name') + '"]').eq(0).attr('checked', true);
								break;
							case 'checkbox':
								$(this).attr('checked', false);
								break;
							case 'select-one':
							case 'select-multi':
								$(this).find('options').removeAttr('selected');
								this.selectedIndex = 0;
								break;
						}
					});
					$form.trigger('submit');
				}
			}, reset_selector);

		return $(this).trigger('ready');
	};
});